import CreateYourOwnContainer from "@/cyo/components/CreateYourOwnContainer";

import styles from "./CreateYourOwn.module.css";

interface CreateYourOwnCTAProps {
  courseNames?: string[];
  hotels?: Record<string, { name: string }>;
  venueName?: string;
  isEu?: boolean;
}

function CreateYourOwn(props: CreateYourOwnCTAProps) {
  const { courseNames = [], hotels = {}, venueName = "", isEu = false } = props;

  return (
    <section className={styles.cyoSection}>
      <div className={styles.left}>
        <h2>Tailor Your Perfect Golf Break</h2>
        <p>
          Can't find the exact dates, courses, or package you need? Share your
          dream golf itinerary with us. Tell us about your group size, specific
          dates and golf choices, and our specialists will craft a bespoke quote
          just for you.
        </p>
      </div>
      <div className={styles.right}>
        <CreateYourOwnContainer
          courseNames={courseNames}
          hotels={hotels}
          venueName={venueName}
          isEu={isEu}
        />
      </div>
    </section>
  );
}

export default CreateYourOwn;
